import {nanoid} from 'nanoid';
import {openDialog, type DialogProps} from 'platform/components';
import {foundationTheme} from 'platform/foundation';

import type {ReactNode} from 'react';

import {BulkOperationActionDialogContent} from '../components/BulkOperationActionDialogContent/BulkOperationActionDialogContent';
import type {BulkOperationActionCallbackParams} from '../types/BulkOperationActionCallback';

export function openBulkOperationActionDialog(
  action: BulkOperationActionCallbackParams,
  content: ReactNode,
  size: DialogProps['size'] = 'default'
) {
  if (action.context.getSnapshot().isClosed) {
    return Promise.resolve();
  }
  return new Promise<void>((resolve) => {
    const dialogId = nanoid();
    openDialog(
      <BulkOperationActionDialogContent action={action} dialogId={dialogId} onDismiss={resolve}>
        {content}
      </BulkOperationActionDialogContent>,
      {
        id: dialogId,
        title: action.actionDefinition.title,
        size: window.matchMedia?.(foundationTheme.devices.mobile)?.matches ? 'xLarge' : size,
        onCloseComplete: resolve,
        'data-testid': action['data-testid'],
      }
    );
  });
}
